import ProductsBlock from 'components/ProductsBlock';

function Home() {
  return <ProductsBlock type="best sellers" />;
}

export default Home;
